import React, { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Backdrop, CircularProgress, Button } from '@mui/material';

// project imports
import Services from 'utils/serviciosVentas';
import Inicio from './Inicio';
import HomeVentas from './HomeVentas';
import MainCard from 'ui-component/cards/MainCard';
import InicioV2 from './InicioV2';
import VistaCurso from './InicioV2/VistaCurso';
import { AvisoConfirmacion, ModalGeneral } from 'ui-component';
import { makeStyles } from '@mui/styles';
import VideoBienvenida from './InicioV2/VideoBienvenida';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    btnAceptar: {
        color: theme.palette.btn.green,
        '&:hover': {
            backgroundColor: theme.palette.btn.green,
            color: theme.palette.btn.white
        }
    },
    btnCancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    },
    btnIngresar: {
        color: theme.palette.btn.blue,
        '&:hover': {
            backgroundColor: theme.palette.btn.blue,
            color: theme.palette.btn.white
        }
    }
}));

// ==============================|| DEFAULT DASHBOARD ||============================== //

const Index = ({ permisos, usuario, option, esIncognito }) => {
    const services = Services();
    const classes = useStyles();
    const theme = useTheme();
    const [terminado, setTerminado] = useState(true);
    const [modal, setModal] = useState({});
    const [confirm, setConfirm] = useState({ open: false });

    // States
    const [arbolCursos, setArbolCursos] = useState({
        grupos: [],
        cursos: [],
        sesion: [],
        temario: [],
        clasificacion: [],
        calificacion: 0,
        aciertos: 0,
        desaciertos: 0,
        actividades: []
    });
    const [cursoActual, setCursoActual] = useState(null);
    // const [modulo, setModulo] = useState(0);
    // const [colaboradores, setColaboradores] = useState([]);
    const [ranking, setRanking] = useState({ posicion: 0, topTen: [] });
    // const [videoData, setVideoData] = useState({});
    const [contacto, setContacto] = useState([]);
    const [cargando, setCargando] = useState({ open: false });
    // const [hasCursos, setHasCursos] = useState(true);
    const [listaCursos, setListaCursos] = useState([]);

    // Services
    const getArbolCursos = () => {
        setCargando({ open: true });
        const idcrm = usuario.idCRM ? usuario.idCRM : null;
        services.Allcursos(
            (data) => {
                setArbolCursos({
                    ...arbolCursos,
                    cursos: data.cursos,
                    clasificacion: data.clasificacion
                });
                if (data?.cursos?.length == 0) setHasCursos(false);
                setRanking(data.ranking);
                setContacto({
                    nombre: data.datosGenerales?.nasesor,
                    telefono: data.datosGenerales?.telefono,
                    correo: data.datosGenerales?.email,
                    depto: usuario.depto
                });
                if (data.datosGenerales) setVideoData({ linkDrop: data.datosGenerales.linkDrop });
                setCargando({ open: false });
            },
            {
                idColaborador: usuario.idColaborador,
                idGrupo: usuario.idGrupo,
                option,
                idContrato: usuario.idcontrato,
                depto: usuario.depto,
                idcrm: idcrm
            }
        );
    };

    // const getColaboradores = () => {
    //     services.colaboradoresMiSede((colaboradores) => setColaboradores(colaboradores));
    // };

    // Functions

    const cambiaCurso = (elegido) => {
        if (elegido != null && elegido.idCurso) {
            //si el grupo es de administrativo(2) se bloquea cuando ya pase su tiempo de acceso
            if (elegido.tipoGrupo == 2) {
                let hoy = moment();
                let fechaInicio = moment(elegido.fechaInicio);
                let fechaFin = moment(elegido.fechaFin);
                if (hoy >= fechaInicio && hoy <= fechaFin) {
                    setCursoActual(elegido);
                }
            } else {
                setCursoActual(elegido);
            }
        } else {
            setCursoActual(null);
        }
    };

    const desbloquea = () => {
        setTerminado(false);
    };
    const mostrarVideoDepartamento = () => {
        const videoDepartamentoVisto = usuario.videoDepartamentoVisto;
        const loginSessionId = sessionStorage.getItem('loginSessionId');
        const videoDepartamentoCerrado = sessionStorage.getItem('videoDepartamentoCerrado_' + loginSessionId);

        if (videoDepartamentoCerrado === 'true') {
            return;
        }

        if (videoDepartamentoVisto === null || videoDepartamentoVisto === 0 || videoDepartamentoVisto === '0') {
            if (usuario.depto) {
                setCargando({ open: true });

                services.getVideoDepartamento(
                    (videoDepto) => {
                        setCargando({ open: false });

                        if (videoDepto && videoDepto.linkDrop) {
                            const bloqueado = videoDepartamentoVisto === null;
                            setTerminado(bloqueado);
                            setModal({
                                open: true,
                                titulo: videoDepto.titulo || 'Video de Bienvenida - Departamento',
                                props: {
                                    link: videoDepto.linkDrop,
                                    desbloquea: () => {
                                        setTerminado(false);
                                    },
                                    bloqueado: bloqueado
                                },
                                componente: VideoBienvenida,
                                cerrar: () => {
                                    abreConfirmacionVideoDepartamento(usuario);
                                }
                            });
                        } else {
                            console.log('1.-VIDEO DEPARTAMENTO NO DISPONIBLE');
                            sessionStorage.setItem('videoDepartamentoCerrado_' + loginSessionId, 'true');
                        }
                    },
                    { idDepto: usuario.depto }
                );
            } else {
                console.log('2.- VIDEO DEPARTAMENTO NO DISPONIBLE');
                sessionStorage.setItem('videoDepartamentoCerrado_' + loginSessionId, 'true');
            }
        } else {
            console.log('3.- VIDEO MARCADO EN EL PRIMER ELSE');
            sessionStorage.setItem('videoDepartamentoCerrado_' + loginSessionId, 'true');
        }
    };
    const abreConfirmacionVideoDepartamento = (usuario) => {
        setConfirm({
            open: true,
            text: '¿Desea ver el video en su siguiente acceso a la plataforma?',
            aceptar: () => {
                setCargando({ open: true });
                //services.agregaPrimerUso(
                services.marcarVideoDepartamentoVisto(
                    (data) => {
                        const loginSessionId = sessionStorage.getItem('loginSessionId');
                        console.log('4.- VIDEO MARCADO EN EL PRIMER IF');

                        sessionStorage.setItem('videoDepartamentoCerrado_' + loginSessionId, 'true');
                        setCargando({ open: false });
                        setConfirm({ open: false });
                        setModal({ open: false });
                    },
                    { idColaborador: usuario.idColaborador }
                );
            },

            cancelar: () => {
                setCargando({ open: true });
                services.marcarVideoDepartamentoVerNuevamente(
                    (data) => {
                        const loginSessionId = sessionStorage.getItem('loginSessionId');
                        console.log('5.- VIDEO MARCADO EN EL SEGUNDO IF');
                        sessionStorage.setItem('videoDepartamentoCerrado_' + loginSessionId, 'true');
                        setCargando({ open: false });
                        setConfirm({ open: false });
                        setModal({ open: false });
                    },
                    { idColaborador: usuario.idColaborador }
                );
            }
        });
    };

    useEffect(() => {
        if (usuario && usuario != null && usuario.linkDrop != null && (!esIncognito || esIncognito == false)) {
            // const primerUso = String(usuario.esPrimerUso);
            // const videoMostradoEnSesion = sessionStorage.getItem('videoMostrado');
            const esNuevo = usuario.esPrimerUso;
            const loginSessionId = sessionStorage.getItem('loginSessionId');
            if (!loginSessionId) {
                return;
            }
            const videoBienvenidaCerrado = sessionStorage.getItem('videoBienvenidaCerrado_' + loginSessionId);
            const videoDepartamentoCerrado = sessionStorage.getItem('videoDepartamentoCerrado_' + loginSessionId);
            if (videoBienvenidaCerrado === 'true') {
                if (videoDepartamentoCerrado !== 'true') {
                    setTimeout(() => {
                        mostrarVideoDepartamento();
                    }, 500);
                } else {
                }
                return;
            }
            if (esNuevo === null || esNuevo === 0 || esNuevo === '0') {
                setTerminado(true); // Botón cerrar bloqueado
                setModal({
                    open: true,
                    titulo: 'Bienvenido a Universidad Maderas',
                    props: { link: usuario.linkDrop, desbloquea: desbloquea, bloqueado: true },
                    componente: VideoBienvenida,
                    cerrar: () => {
                        setCargando({ open: true });

                        services.agregaPrimerUso(
                            (data) => {
                                const loginSessionId = sessionStorage.getItem('loginSessionId');
                                sessionStorage.setItem('videoBienvenidaCerrado_' + loginSessionId, 'true');
                                setCargando({ open: false });
                                setModal({ open: false });

                                // Mostrar video de departamento
                                setTimeout(() => {
                                    mostrarVideoDepartamento();
                                }, 500);
                            },
                            { idColaborador: usuario.idColaborador }
                        );
                    }
                });
                // sessionStorage.setItem('videoMostrado', 'true');
            } else {
                sessionStorage.setItem('videoBienvenidaCerrado_' + loginSessionId, 'true');

                // Verificar video de departamento
                if (videoDepartamentoCerrado !== 'true') {
                    setTimeout(() => {
                        mostrarVideoDepartamento();
                    }, 500);
                }
            }
        }
    }, [usuario]);

    return (
        <>
            {/* {modulo ? (
                <HomeVentas
                    esIncognito={esIncognito}
                    arbolCursos={arbolCursos}
                    setArbolCursos={setArbolCursos}
                    ranking={ranking}
                    info={contacto}
                    // colaboradores={colaboradores}
                    curso={arbolCursos.cursos.find((curso) => curso.idCurso == modulo)}
                    unselectCurso={unselectCurso}
                    permisos={permisos}
                    usuario={usuario}
                    option={option}
                />
            ) : ( */}
            {/* <Inicio
                usuario={usuario}
                cursos={arbolCursos.cursos}
                selectCurso={selectCurso}
                ranking={ranking}
                info={contacto}
                videoData={videoData}
                hasCursos={hasCursos}
                clasificacion={arbolCursos.clasificacion}
            /> */}
            {/* )} */}

            {cursoActual != null ? (
                <VistaCurso
                    usuario={usuario}
                    cursoActual={cursoActual}
                    regresaCurso={cambiaCurso}
                    contacto={contacto}
                    ranking={ranking}
                    permisos={permisos}
                />
            ) : (
                <InicioV2 usuario={usuario} selectCurso={cambiaCurso} setCargando={setCargando} option={option} esIncognito={esIncognito} />
            )}

            <ModalGeneral
                open={modal?.open}
                titulo={modal?.titulo}
                width="lg"
                acciones={
                    <Button disabled={terminado} onClick={modal?.cerrar} className={classes.btnCancelar}>
                        Cerrar
                    </Button>
                }
            >
                {modal?.componente && <modal.componente {...modal?.props} />}
            </ModalGeneral>

            <AvisoConfirmacion
                open={confirm.open}
                title="Video Bienvenida"
                text={confirm.text}
                accept={confirm.aceptar}
                textAcept={'No, gracias'}
                cancel={confirm.cancelar}
                textCancel={'Si, por favor'}
            />

            <Backdrop open={cargando.open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default Index;
